import { read } from "lib/storage";
import { DefaultLocale, Locale, AllLocales } from "models/locale";
import { StateCreator } from "zustand";

export interface LocaleSlice {
  locale: Locale;
}

// parses the browser locale for the initial state
export const getInitialLocale = () => {
  // prefer localStorage
  const cached = read<Locale>("locale");
  if (cached && AllLocales.includes(cached)) {
    return cached;
  }

  const parsed = navigator.language.split("_")[0] as Locale;
  if (AllLocales.includes(parsed)) {
    return parsed;
  }

  // default to EN
  return DefaultLocale;
};

export const createLocaleSlice: StateCreator<
  LocaleSlice,
  [],
  [],
  LocaleSlice
> = () => ({
  locale: getInitialLocale(),
});
